// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-preview-js": () => import("./../../../src/pages/preview.js" /* webpackChunkName: "component---src-pages-preview-js" */),
  "component---src-templates-catalog-jsx": () => import("./../../../src/templates/catalog.jsx" /* webpackChunkName: "component---src-templates-catalog-jsx" */),
  "component---src-templates-modulaire-jsx": () => import("./../../../src/templates/modulaire.jsx" /* webpackChunkName: "component---src-templates-modulaire-jsx" */)
}

